import {onFind} from "@elements/init-modules-in-scope";
import Modal from 'bootstrap/js/dist/modal';

export function init () {
    onFind('.js-info-modal', function(element) {
        const urlParams = new URLSearchParams(window.location.search)
    if(element && !urlParams.has('affiliate')){
        let modalInstance = element.dataset.instance;
        let infoModal = new Modal(element);
        if (!sessionStorage.getItem(modalInstance)) {
            infoModal.show();
        }
        element.addEventListener('hide.bs.modal', function () {
            sessionStorage.setItem( modalInstance,'closed');
        });
    }
});
}